import { FC } from 'react';
import { Helmet } from 'react-helmet-async';
import Terms from 'core/Auth/Terms';
import css from './EULA.module.css';

export const EULA: FC = () => {
  return (
    <div className={css.container}>
      <Helmet>
        <title>Terms</title>
        <meta name="description" content="Terms" />
      </Helmet>

      <div className={css.content}>
        <div className={css.header}>
          <h1>CyberProof | Interpres Platform Terms</h1>
        </div>

        <div className={css.termsContainer}>
          <Terms email="" />
        </div>
      </div>
    </div>
  );
};

export default EULA;
